
export default {
  props: {
    value: {
      type: [String, Number, Object],
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
      selectedLabel:'请选择',
      showTooltipContent:false,
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
  },
  watch: {
    value: {
      handler(newVal) {
        let label =('我的文件'+newVal)
        this.selectedLabel = label.substring(0, label.length - 1)
      },
      immediate: true,
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    closeDropdown() {
      this.isOpen = false
    },
    nodeClick(data){
      this.$emit('input', data.path)
      this.$emit('folder', data)
    },
    /**
     * 鼠标悬停3秒
     */
    showTooltip({ x, y }) {
      this.tooltipX = x
      this.tooltipY = y + 10
      this.showTooltipContent = true
    },
    /**
     * 关闭回显
     */
    hideTooltip() {
      this.showTooltipContent = false
    },
  },
}
